import { inject, observer } from "mobx-react";
import React from "react";
import { UpgradeButton } from "@fidget/common/components/button/upgradeButton";
import { IUiStore } from "../../models/ui/UiStore";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "@fidget/common/components/mstchat/chatNotification.css";
import classNames from "classnames";

interface Props {
  message: JSX.Element | string;
  uiStore?: IUiStore;
}

@inject("uiStore")
@observer
export class CTANotification extends React.Component<Props, {}> {
  render() {
    const { message } = this.props;

    return (
      <div className={classNames(styles.event, styles.dashboard)}>
        <div className={styles["cta-event-text"]}>
          <span>{message}</span>
          <div className={styles["cta-upgrade"]}>
            <UpgradeButton
              text={intl.formatMessage("plan.upgrade.chat.cta.calls")}
              whiteStyle
              onClick={this.props.uiStore!.changeUpgrade}
            />
          </div>
        </div>
      </div>
    );
  }
}
